module.exports = __webpack_public_path__ + "static/media/mp.bccdcb5e.svg";